import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { fetch } from '../../service_broker/fetch';
import { ACTION_SUBMIT_BULK_ACTIONS } from '../../store/state/actions';
import { resolveRestApi } from '../../router/app-router';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { getSubmitData, processHeaders } from '../../store/state/epics/util';
import type { Action } from '../../store/state/state-manager';

export const executeSubmitBulkActionAsyncRequest = (actionInPayload: Action['payload']) => {
  const { actionID, context, cases } = actionInPayload;
  const { content } = getSubmitData(context, { nonEmptyAndChangedData: true });

  content.cases = cases.map((caseID: string) => ({ ID: caseID }));
  const routeKey = ACTION_SUBMIT_BULK_ACTIONS;
  const { reqType, restApi } = resolveRestApi(routeKey, { actionID, runningMode: 'async' });

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        body: content
      },
      context
    )
  ).pipe(
    map((response) => {
      const { data, headers } = response;
      return {
        response: data,
        actionInPayload,
        headers: processHeaders({ ...headers })
      };
    }),
    logAndCatchError('Error occurred during ajax call at submitbulkaction Epic : ', context)
  );
};

export default {
  executeSubmitBulkActionAsyncRequest
};
